import _ from "lodash";
import webStorageManager from "../../../services/managers/web-storage";
import securityManager from "../../../services/managers/security";
import pagePreloaderManager from "../../../services/managers/page-preloader";
import alertMessageManager from "../../../services/managers/alert-message";
import appDataTransformer from "../../../services/transformers/app-data";
import { STORAGE_KEY_APP_DATA, SELECT_EMPTY_VALUE, STORAGE_KEY_HOLIDAYS, STORAGE_KEY_HOLIDAYSTITLE } from "../../../services/managers/constants";

export const onAppLoad = (state, action) => {
  if (action.payload.error) {
    alertMessageManager.show("globalAlertError", action.payload.error);
    pagePreloaderManager.hide();
    return { ...state };
  }

  let products = [];
  let selectedProduct = SELECT_EMPTY_VALUE;
  let costToTradeLotSizes = [];
  let chartWhiteboards = state.chartWhiteboards.slice();
  let chartWhiteboardsLen = chartWhiteboards.length;

  // Cache initial app data for later use
  webStorageManager.set(STORAGE_KEY_APP_DATA, action.payload.response);

  // Cache list of holidays for later use
  webStorageManager.set(STORAGE_KEY_HOLIDAYS, window.HOLIDAYS);
  webStorageManager.set(STORAGE_KEY_HOLIDAYSTITLE, window.HOLIDAYSTITLE);

  // Fetch all Products to populate the Product filter
  products = appDataTransformer.getAllProducts();

  // Set default product as the default selection
  // If default product is not available, set the first product as default selection
  let defaultProduct = _.isString(action.payload.response.App.DefaultProduct)
    ? _.find(products, { ProductCode: action.payload.response.App.DefaultProduct })
    : undefined;
  selectedProduct = _.isObject(defaultProduct) ? defaultProduct["ProductCode"] : products[0]["ProductCode"];

  // Fetch new set of Lot Sizes mapped to selected Product
  costToTradeLotSizes = appDataTransformer.getAllLotSizesByProduct(action.payload.response.App.Products, selectedProduct);

  for (let index = 0; index < chartWhiteboardsLen; index++) {
    let whiteboard = { ...chartWhiteboards[index] };
    // Set selected Lot Sizes in all Whiteboards to the first Lot Size
    whiteboard.selectedCostToTradeLotSizes = [];
    whiteboard.selectedCostToTradeLotSizes[0] = costToTradeLotSizes[0].Key;
    whiteboard.__change_detection_key = securityManager.generateKey();
    chartWhiteboards[index] = whiteboard;
  }

  pagePreloaderManager.hide();
  return { ...state, products, selectedProduct, costToTradeLotSizes, chartWhiteboards };
};



// WEBPACK FOOTER //
// ./src/store/analytics/analytics/action-handlers.js